import React from "react";
import {
  Box,
  Stack,
  Card,
  Group,
  Text,
  Title,
  Badge,
  Center,
  ScrollArea,
} from "@mantine/core";
import { constellationBlueprint } from "../../../../../hooks/corral/graph-structure/blueprint";

const glyphLookup = new Map(
  constellationBlueprint.quadrants.map((q) => [q.id, q]),
);

const quadrantOrder = {
  source: 0,
  freedom: 1,
  death: 2,
  creation: 3,
  improvement: 4,
  change: 5,
  life: 6,
  lies: 7,
  truth: 8,
};

const TreeAbilities = ({ treeId, glyphs, maxHeight = 400 }) => {
  const slots = glyphs
    .map((slot) => {
      const glyph = glyphLookup.get(slot.glyphId);
      return glyph ? { ...slot, glyph } : null;
    })
    .toSorted(
      (a, b) => quadrantOrder[a.quadrantId] - quadrantOrder[b.quadrantId],
    )
    .filter(Boolean);
  return (
    <Box my="sm" style={{ minWidth: "100%" }}>
      <Center>
        <Title order={4} mb="sm" style={{ textTransform: "capitalize" }}>
          {treeId}
        </Title>
      </Center>

      {slots.length > 0 && (
        <ScrollArea
          style={{
            maxHeight: maxHeight,
            overflowY: "auto",
            transition: "max-height 200ms ease",
          }}
        >
          <Stack spacing="sm">
            {slots.map((slot) => (
              <Card key={slot.id} withBorder radius="md" p="sm">
                <Group position="apart" mb="xs">
                  <Text
                    size="xs"
                    c="dimmed"
                    style={{ textTransform: "capitalize" }}
                  >
                    {slot.quadrantId}
                  </Text>
                  <Badge
                    autoContrast
                    color={slot.glyph.backgroundColor}
                    variant="filled"
                    style={{ outline: "1px solid grey" }}
                  >
                    {slot.glyph.displayName}
                  </Badge>
                </Group>
                <Text size="sm">{slot.description}</Text>
                {slot.variantDescription && (
                  <Text
                    size="sm"
                    sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                  >
                    <Text component="span" fw="bold">
                      Variant:&nbsp;
                    </Text>
                    {slot.variantDescription}
                  </Text>
                )}
              </Card>
            ))}
          </Stack>
        </ScrollArea>
      )}
    </Box>
  );
};

export default TreeAbilities;
